import { DrillUtil } from 'kuaidong-lib'
import { HomeworkStudentSmartCheck } from 'kuaidong-model'

export function formatCheckResult(result: HomeworkStudentSmartCheck | null) {
  if (result === 'normal' || result === 'teacher_judge_qualified') {
    return DrillUtil.AiLabelNormalCn
  } else if (result === 'no_rope' || result === 'teacher_judge_no_rope' || result === 'no_rope_appealed') {
    return DrillUtil.AiLabelNoRopeCn
  } else if (result === 'double_jump' || result === 'teacher_judge_double_jump' || result === 'double_jump_appealed') {
    return DrillUtil.AiLabelDoubleJumpCn
  } else if (result === 'teacher_judge_others') {
    return '不合格'
  } else if (result === DrillUtil.AiLabelFakePeople) {
    return DrillUtil.AiLabelFakePeopleCn
  } else {
    return '-'
  }
}

export function isPending(result: HomeworkStudentSmartCheck | null) {
  return !!result && ['no_rope_appealed', 'double_jump_applealed'].includes(result)
}

export function isValid(result: HomeworkStudentSmartCheck | null) {
  return !!result && ['normal', 'teacher_judge_qualified'].includes(result)
}

export function isUnqualified(result: HomeworkStudentSmartCheck | null) {
  return (
    !!result &&
    [
      'no_rope',
      'double_jump',
      'teacher_judge_no_rope',
      'teacher_judge_double_jump',
      'teacher_judge_others',
      DrillUtil.AiLabelFakePeople,
    ].includes(result)
  )
}

export function finishRate2Status(rate: number) {
  if (rate <= 0) {
    return 'un_start'
  } else if (rate >= 1) {
    return 'done'
  } else {
    return 'uncompleted'
  }
}
